// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const config: any = {
  apiKey: 'AIzaSyC-h8QCp1sBAF0JGXxRAgtSm1qjOLbgJAc',
  authDomain: 'ea-golf-dev.firebaseapp.com',
  databaseURL: 'https://ea-golf-dev.firebaseio.com',
  projectId: 'ea-golf-dev',
  storageBucket: 'ea-golf-dev.appspot.com',
  messagingSenderId: '225434260960',
  appId: '1:225434260960:web:6a17adc064ab83273e0785',
  measurementId: 'G-4REL5L1RKN',
  recaptchaEnterpriseKey: '6LeXCGkqAAAAAJDK3y2OCDDGguU9uLd-nf8ciBYh',
};

// if (location.hostname === 'localhost') {
//   config.databaseURL = 'http://localhost:4000?ns=<ea-golf-dev>';
//   config.authDomain = 'localhost:9099';
// }

export const environment = {
  production: false,
  firebase: config,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
